import React from 'react'
import AssignmentForm from '../components/assignment-form'
import QuestionBank from '../components/question-bank'

const ProjectSidebar = ({
  assignment,
  data,
  lastDueAt,
  onCancel,
  onMetaSave,
}) => {
  return (
    <aside id="project-sidebar">
      {assignment ? (
        <AssignmentForm
          {...assignment}
          key={assignment.id}
          data={data}
          onCancel={onCancel}
          onMetaSave={onMetaSave}
          lastDueAt={lastDueAt}
        />
      ) : (
        <QuestionBank />
      )}
    </aside>
  )
}

export default ProjectSidebar
